import React from 'react';
import { Navbar } from '../../components';
import { EducationHeader } from '../../containers';

const Education = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <EducationHeader />
        </div>
    </div>
  )
}

export default Education